import styles from './index.module.scss';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OldSupportPolicy from '@/components/OldSupportPolicy';
import PageLayout from '@/components/PageLayout';
import SupportBannerH5 from '@/componentsH5/SupportCommon/SupportBanner';
import SupportBanner from '@/components/SupportCommon/SupportBanner';
import Crum from '@/components/Crum';
import SupportPolicyPc from '@/components/SupportPolicy';
import SupportPolicyH5 from '@/componentsH5/SupportPolicy';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/support/policy';

export default function Policy({ lang, SEO, policyData }: any) {
    const { isMobile, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared');
    const breadcrumbData = [{ name: t('crums.crum_home'), link: '/' }, { name: t('crums.crum_support'), link: '/support' }, { name: t('crums.crum_policy') }];
    const SupportPolicy = isMobile ? SupportPolicyH5 : SupportPolicyPc;

    return (
        <PageLayout isNoFixed={true}>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            {!policyData && <OldSupportPolicy lang={lang} />}
            {policyData && (
                <div className={styles.policy}>
                    {isMobile ? <SupportBannerH5 /> : <SupportBanner />}
                    <Crum data={breadcrumbData} />
                    <SupportPolicy lang={lang} policyData={policyData} />
                </div>
            )}
        </PageLayout>
    );
}

// 日本站屏蔽该地址
export async function getServerSideProps({ locale }: { locale: string }) {
    const whiteLocaleList = ['jp'];
    if (whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }
    const newSupportPolicy = ['uk', 'cn', 'de', 'fr', 'es', 'it', 'sa', 'eu', 'au', 'nl'];
    let data = null;
    try {
        if (newSupportPolicy.includes(locale)) data = require(`@/data/policy/${locale}`);
    } catch (err) {
        console.log(err);
    }
    return {
        props: {
            policyData: data,
        },
    };
}
